/**
 * UserMenuButton Component
 * STANDALONE - Toggle button for UserPreferences dropdown
 * Created: 2025-12-23 14:40 EST
 * Updated: 2025-12-23 15:00 EST - Now uses UserPreferences instead of UserMenu
 * Updated: 2025-12-23 - Added login status indicator dot
 */

import { useState } from 'react'
import UserPreferences from './UserPreferences/UserPreferences'
import AuthModal from '../../components/AuthModal'
import { useAuthStore } from '../../stores/authStore'
import './UserMenuButton.css'

function UserMenuButton() {
  const [isOpen, setIsOpen] = useState(false)
  const [authModalOpen, setAuthModalOpen] = useState(false)
  const [authModalMode, setAuthModalMode] = useState('login')
  const user = useAuthStore((state) => state.user)

  const handleOpenAuth = (mode = 'login') => {
    setIsOpen(false) // Close preferences dropdown
    setAuthModalMode(mode)
    setAuthModalOpen(true)
  }

  return (
    <div className="user-menu-wrapper">
      <button
        className="user-toggle"
        onClick={() => setIsOpen(!isOpen)}
        title={user ? 'Preferences (Signed In)' : 'Preferences (Guest)'}
      >
        <i className="fas fa-user"></i>
        <span className={`status-dot ${user ? 'online' : 'offline'}`}></span>
      </button>

      <UserPreferences
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onOpenAuth={handleOpenAuth}
      />

      <AuthModal
        isOpen={authModalOpen}
        onClose={() => setAuthModalOpen(false)}
        initialMode={authModalMode}
      />
    </div>
  )
}

export default UserMenuButton
